import {NEW_USER, OLD_USER} from '../utils/actionTypes';

const INITIAL_STATE = {
  new_user : false
}

const userType = (state = INITIAL_STATE, action) => {
  switch(action.type){
    case NEW_USER : return {...state, new_user: true};
    case OLD_USER: return {...state, new_user: false}
    default: return state;
  }
}

export default userType;


// WEBPACK FOOTER //
// ./src/reducers/userType.js